var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('PageTitle', {
    attrs: {
      "title": _vm.pageTitle,
      "title-tag": "h2",
      "back-button": {
        url: _vm.allArticlesUrl,
        hiddenAfterSizes: 'sm'
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "px-20 px-sm-30 py-20 py-sm-30 py-lg-40 pages-wrapper"
  }, [_c('div', {
    staticClass: "new-container blog-container mx-auto",
    attrs: {
      "dir": _vm.$dir()
    }
  }, [_c('div', {
    staticClass: "tp-4 opa-70 pl-20 mb-20 d-none d-sm-block"
  }, [_c('nuxt-link', {
    attrs: {
      "to": _vm.localePath(_vm.allArticlesUrl)
    }
  }, [_vm.$dir() === 'rtl' ? [_vm._v(" → ")] : [_vm._v(" ← ")], _vm._v("\n          " + _vm._s(_vm.viewAllArticlesLink) + "\n        ")], 2)], 1), _vm._v(" "), _c('article', {
    staticClass: "d-grid grid-cols-1 grid-cols-sm-12 gap-sm-30 publishing-detail-container px-20 px-sm-30 px-lg-0"
  }, [_c('div', {
    staticClass: "col-span-sm-12 col-span-lg-8 col-start-lg-3 d-grid gap-20 py-20 py-sm-30 py-lg-40"
  }, [_c('div', [_c('header', {
    staticClass: "marg-bottom-2 tx-center"
  }, [_c('h1', {
    staticClass: "tp-1-2"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('div', {
    staticClass: "tp-7 opa-70"
  }, [_c('client-only', [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.articlePublishedAt) + "\n                    "), _vm.article.reading_time ? [_vm._v("\n                      /\n                      "), _c('span', {
    staticClass: "text-transform-default"
  }, [_vm._v(_vm._s(_vm.$t('scenes.blog.minute-read', {
    minute: _vm.article.reading_time
  })))])] : _vm._e()], 2)])], 1), _vm._v(" "), _vm.author ? _c('Author', {
    staticClass: "justify-content-center",
    attrs: {
      "author": _vm.author
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "article-content tp-5",
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  }), _vm._v(" "), _vm.author ? [_c('hr'), _vm._v(" "), _c('Author', {
    attrs: {
      "author": _vm.author,
      "withBio": true
    }
  })] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "d-grid grid-cols-1 grid-cols-sm-12 gap-sm-30"
  }, [_c('div', {
    staticClass: "col-span-sm-6 col-start-sm-4 col-span-lg-4 col-start-lg-5 d-grid gap-20 pt-20 pt-sm-30 pt-lg-40"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "d-inline-block text-decoration-none call-to-action dark w-100",
    attrs: {
      "to": _vm.localePath(_vm.allArticlesUrl)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.viewAllArticlesButton) + "\n            ")])], 1)])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }